module.exports = __webpack_public_path__ + "img/img_11.bad47cb7.png";